module.exports = __webpack_public_path__ + "static/media/hamburger-menu-desk.e7c00b9a.svg";